import { render, staticRenderFns } from "./CreatePlpDialog.vue?vue&type=template&id=50f17914"
import script from "./CreatePlpDialog.ts?vue&type=script&lang=ts&external"
export * from "./CreatePlpDialog.ts?vue&type=script&lang=ts&external"
import style0 from "./CreatePlpDialog.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports